/// <amd-module name="Test/TestResultDetails/TelemetryConstants" />
export const featureTestTab_StackTraceClicked = "NewTestTab_StackTraceClicked";
export const featureTestTab_StackTraceLinksCreated = "NewTestTab_StackTraceLinksCreated";
export const featureTestTab_TestRunComment: string = "NewTestTab_TestRunComment";
export const featureTestTab_DebugPivotViewed: string = "NewTestTab_DebugPaneViewed";
export const featureTestTab_markdownViewed: string = "NewTestTab_MarkdownViewed"